import React, {Component} from "react";
import "./Modal.scss";

export default class Modal extends Component {
    constructor(props) {
        super(props);
    }

    #closeHandler = (event, closable = true) => {
        if (closable) {
            event && event.stopPropagation();
            let modalContainer = document.querySelector(".custom-modal__container");
            if (event.target.contains(modalContainer))
                this.props.closeHandler(closable);
        }
    }

    render() {
        const { logo = null, classes="", noHeader = false, title = "", description = "", closable = true, children = null } = this.props;
        return <div className={`custom-modal ${classes}`} onClick={e => this.#closeHandler(e, closable)}>
            <div className="custom-modal__container">
                <div>
                    {
                        !noHeader &&
                        <div className="custom-modal__header">
                            { logo && <img src={logo} alt="SPAX logo"/> }
                            <h5 className="title">{ title }</h5>
                            <p className="description">{ description }</p>
                        </div>
                    }
                    <div className="custom-modal__body">
                        {
                            children ?? <p>Nothing To Show</p>
                        }
                    </div>
                </div>
            </div>
        </div>;
    }
}

// Created at 2022/11(November)/07(Monday)
